export default __webpack_public_path__ + "static/media/headerImage.edb5d5db.JPG";